<template>
  <!--      弹框绑定手机-->
  <div :class="getCss('container')" v-if="value"
       v-transfer-dom
  >
    <div :class="getCss('container-mask')"
         @click="handleClose"
         v-if="value"
    >
    </div>
    <div class="pop_up_wrap">
      <div class="title"><span>预约成功</span></div>
      <div class="follow-account-copy-area" v-if="isWX && isFocusOn === false">
        <p class="follow-account-text"><span>
        </span>关注「心悦俱乐部」公众号</p>
        <p class="follow-account-msg-push">推送上线消息直 <span class="user-wx-nick-name" v-html="nickname"></span>(微信)</p>
        <button class="follow-account-copy-btn" @click="copyText">
          <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="200" height="200">
            <path
              d="M921.84736468 997.93033544H101.54506534c-24.68943392 0-44.71162586-20.00838352-44.71162584-44.71162585V631.455181c0-24.70324234 20.02219194-44.71162586 44.71162584-44.71162585s44.71162586 20.00838352 44.71162586 44.71162585v277.05190275h730.87904765V631.455181c0-24.70324234 20.02219194-44.71162586 44.71162583-44.71162585 24.68943392 0 44.71162586 20.00838352 44.71162586 44.71162585V953.21870959c0 24.70324234-20.02219194 44.71162586-44.71162586 44.71162585z"
              fill="#ffffff" p-id="3540"></path>
            <path
              d="M511.69621502 839.9897621c-24.68943392 0-44.71162586-20.00838352-44.71162585-44.71162585V70.54383027c0-24.70324234 20.02219194-44.71162586 44.71162585-44.71162586s44.71162586 20.00838352 44.71162585 44.71162586v724.73430598c0 24.70324234-20.02219194 44.71162586-44.71162585 44.71162585z"
              fill="#ffffff" p-id="3541"></path>
            <path
              d="M511.69621502 869.73307344c-14.37455297 0-27.92060144-6.93182094-36.30230524-18.61373431L323.62569491 639.87831001c-14.41597819-20.04980875-9.84539506-47.998027 10.21822209-62.41400518 20.02219194-14.37455297 47.94279339-9.85920347 62.3863884 10.21822208l115.47971803 160.70225499 115.45210121-160.68844659c14.443595-20.09123397 42.37800485-24.60658347 62.38638839-10.23203048 20.04980875 14.41597819 24.62039188 42.33657964 10.21822208 62.40019679l-151.75440644 211.2272207a44.65639221 44.65639221 0 0 1-36.31611365 18.64135112z"
              fill="#ffffff"></path>
          </svg>
          复制公众号名称
        </button>
      </div>
      <div class="follow-account-area" v-if="!isWX">
        <p>关注「心悦俱乐部」微信公众号,</p>
        <p>第一时间获得最新福利信息</p>
      </div>

      <div class="follow-account-area" v-if="isWX && isFocusOn === true">
        <p>关注「心悦俱乐部」公众号将推送上线通知至:</p>
        <p><span class="user-wx-nick-name" v-html="nickname"></span>(微信)</p>
      </div>
      <div class="input-order-set-phone-container">
        <div class="input-order-phone-area">
          <p>上线短信通知</p>
          <label>
            <input class="push-notice-switch push-notice-switch-animation"
                   v-model="openNoticeMsg"
                   type="checkbox">
          </label>
        </div>

        <input class="pop_input" v-if="openNoticeMsg" v-model="phone" type="text"
               oninput="if(value.length > 11)value = value.slice(0, 11)"
               :placeholder="placeholderPhone"/>
        <div class="checked_wrap" v-if="!isIOS">
          <!-- 默认选中，取消加disabled -->
          <span
            :class="{
              'checked_icon_wrap' :true,
              'disabled' : !wifiAutoDownloadDisabled
            }"
            @click="wifiAutoDownloadDisabled = !wifiAutoDownloadDisabled"
          >
              <span class="checked_icon"> </span>
            </span>
          游戏开放下载时，WI-FI环境下自动帮你下载
        </div>
        <button class="input-order-phone-submit-btn" @click="save">
          好的
        </button>
      </div>
    </div>

  </div>

</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { common, componentBaseMixin } from '@tencent/ceiba-base-components';
import { tool, TgclubApi } from '@tencent/ceiba-tgclub-base-components';
// import { tool, TgclubApi } from '../ceiba-tgclub-base-components';
import Vue from 'vue';

export default {
  name: 'CTgclubGameOrderBindPhonePop',
  mixins: [componentBaseMixin],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    subscriptionData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      cssPrefix: 'tgclub-game-order-bind-phone-pop-',
      wifiAutoDownloadDisabled: true,
      phone: '',
      placeholderPhone: '请输入手机号码',
      isFocusOn: false,
      openNoticeMsg: true,
      switchStatus: 0, // 0 打开 1 关闭
      packageName: '', // 游戏包
      nickname: '',
    };
  },
  computed: {

    isWX() {
      if (this.$actInfo && this.$ast.isAPP()) {
        return common.tool.getCookie('acctype') === 'wx';
      }
      return this.$platform.isWX;
    },
    isIOS() {
      return this.$platform.isIos;
    },

  },
  watch: {
    subscriptionData: {
      deep: true,
      handler(newValue) {
        const { mobile = '', isFocusOn, switchStatus, nickname } = newValue;
        this.phone = mobile;
        this.openNoticeMsg = switchStatus === 0;
        this.isFocusOn = isFocusOn;
        // 'Tony<span class="emoji emoji1f601"></span>';
        this.nickname = nickname;
        console.log(' this.phone=', this.nickname);
      },
    },
    openNoticeMsg: {
      handler(newVal) {
        this.switchStatus = newVal ? 0 : 1;
        console.log('this.switchStatus ', this.switchStatus);
      },
      immediate: true,
    },
  },
  async mounted() {
    console.log('configurationData pop bind phone=', this.configurationData);
    // await this.initialize();
  },
  methods: {
    copyText() {
      tool.copyText('心悦俱乐部');
      Vue.prototype.$toast('复制公众号名称成功');
      if (this.$ast.isAPP()) {
        // 当期页面切换成微信
        window.Tgclub && window.Tgclub.openApp('com.tencent.mm');
      }
    },
    reportBindPhoneFunc(status) {
      if (typeof this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'bind_phone',
          eventData: {
            status,
          },
        };
        this.reportClickRaw(params);
        console.log('reportFunc bind Phone in order  data =', params);
      }
    },
    // async initialize() {},
    handleClose(status) {
      this.$emit('closeBindOrderPhone', status);
    },
    phoneFormatIsOk(phone) {
      return /^1[3456789]\d{9}$/.test(phone);
    },
    async save() {
      console.log(' this.wifiAutoDownloadDisabled ', this.wifiAutoDownloadDisabled);
      if (this.openNoticeMsg === true) {
        if (!this.phone || this.phone.length < 11) {
          return this.$toast('请输入11位手机号');
        }
        // 设置短信通知
        if (!this.phoneFormatIsOk(this.phone)) {
          return this.$toast('请输入正确格式手机号');
        }
      }

      const reportData = {
        gid: this.subscriptionData.gid,
        mobile: this.phone && this.phoneFormatIsOk(this.phone) ? this.phone : '',
        countrycode: '86',
        switch_status: this.openNoticeMsg ? 0 : 1,
      };
      const response = await TgclubApi.saveMobSubscription(reportData);
      console.log('saveMobSubscription response  =', response);
      const { ret, msg } = response || {};
      if (ret !== 0) {
        this.$alert({ msg: msg || '操作失败' });
        this.reportBindPhoneFunc('0');
      }
      this.reportBindPhoneFunc('1');

      if (!this.isIOS) {
        this.reportSilentDownload();
        return false;
      }
      this.handleClose(true);
    },
    async reportSilentDownload() {
      // 获取游戏包名称
      const actId = Vue.prototype?.$actInfo?.activity_id;
      console.log('reportSilentDownload check actId = ', actId);
      if (actId !== 10524) {
        this.handleClose(true);
        console.log(' stop reportSilentDownload check actId = ', actId);
        return false;
      }
      console.log(' access reportSilentDownload check actId = ', actId);

      if (!this.packageName) {
        const androidPkgName = await TgclubApi.queryGamePackageName(this.subscriptionData.gid);
        if (!androidPkgName) {
          this.$alert({ msg: '获取安卓游戏包名失败' });
          return false;
        }
        this.packageName = androidPkgName;
      }
      const reportData = {
        gid: this.subscriptionData.gid,
        packageName: this.packageName,
        operType: this.wifiAutoDownloadDisabled ? 0 : 1,
      };
      const response = await TgclubApi.reportSilentDownload(reportData);
      console.log('reportSilentDownload response  =', response);
      const { ret, msg } = response;
      if (ret !== 0) {
        this.$alert({ msg: msg || '操作失败' });
      }
      this.handleClose(true);
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
